import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

export interface ProductFormLiveDataWrapperProps {
  /** True when the product already has a live PIM version (`product.localVariants?.length > 0`). */
  isLive: boolean;
  testId?: string;
  children: ReactNode;
}

/**
 * Wraps sections 1 & 2 with a green accent + "taken from the live version"
 * notice when the product already has a live PIM product (§13.3).
 * Renders children unchanged when the product has no live version.
 */
export function ProductFormLiveDataWrapper({ isLive, testId, children }: Readonly<ProductFormLiveDataWrapperProps>) {
  const { t } = useTranslation();

  if (!isLive) {
    return <>{children}</>;
  }

  return (
    <div className="space-y-4 rounded-lg border-2 border-green-500 p-3" data-testid={testId}>
      <p className="rounded border border-green-200 bg-green-500/10 px-3 py-2 text-xs text-green-700 dark:border-green-800 dark:text-green-400">
        {t("views.shopifyImportModal.productForm.liveDataNotice")}
      </p>
      {children}
    </div>
  );
}
